import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import VehicleList from './index';
import VehicleSearch from './VehicleSearch';
import BasicTabs from 'components/BasicTabs';
import { ALL_PERMISSION } from 'constants/permission';

const { TabPane } = Tabs;

const VehicleRecordsRegistration = () => {
  const { t: translation } = useTranslation();
  const listTab = [{
    key: "list",
    label :translation("vehicleRecords.tabs.list"),
    permission: undefined,
    component: <VehicleList />,
  },
  // {
  //   key: "search",
  //   label :translation("vehicleRecords.tabs.search"),
  //   permission: undefined,
  //   component: <VehicleSearch />,
  // },
]
  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_VEHICLE_RECORD.permissionTab} />
  );
};

export default VehicleRecordsRegistration;
